import { memo } from 'react';
import Spinner from '@rio-cloud/rio-uikit/Spinner';

export const Loading = memo(() => (
    <div className={'display-flex justify-content-center margin-top-25'} data-testid={'spinner'}>
        <Spinner />
    </div>
));
